import script from "./ZoneItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ZoneItem.vue?vue&type=script&setup=true&lang=js"

import "./ZoneItem.vue?vue&type=style&index=0&id=a0d57384&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0d57384"]])

export default __exports__